import { layerWindowToVideoSegments } from './layerWindowToVideoSegments';

/**
 * Where should the playhead go when the user selects a layer's timeline lane?
 *
 * Returns a source-video time to seek to, or `null` when no seek is warranted —
 * either the playhead already sits inside the layer (don't yank it away from
 * the frame the user is looking at, e.g. while trimming the layer's end), or
 * the window projects onto nothing.
 *
 * A window spanning a scene cut yields several segments; we seek to the first.
 */
export function resolveLayerSeekTarget(
  layer: { start: number; end: number },
  intervals: Array<{ startTime: number; endTime: number }>,
  currentVideoTime: number,
): number | null {
  const segments = layerWindowToVideoSegments(layer.start, layer.end, intervals);
  if (segments.length === 0) return null;

  const alreadyVisible = segments.some(
    (seg) => currentVideoTime >= seg.videoStart && currentVideoTime < seg.videoEnd,
  );
  if (alreadyVisible) return null;

  return segments[0].videoStart;
}
